module.exports = __webpack_public_path__ + "static/img/home-aricles.7a8084c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-aricles.jpg
// module id = aiPL
// module chunks = 1